import { AxiosInstance } from 'axios';

import { axios } from '../../../api/axios-instance';
import { seasonsEndpoints } from '../../../constants';
import { SeasonType } from '../season.schema';

class SeasonsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getActiveSeasons = async (): Promise<SeasonType> => {
    return this.#requestInstance.get(seasonsEndpoints.seasons);
  };
}

export const seasonsApi = new SeasonsApi(axios);
